import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MenuItem } from '../enums/menu.enum';

@Injectable({
	providedIn: 'root'
})
export class MenuService {
	private _menuSubject: BehaviorSubject<boolean>;

	constructor(protected translateService: TranslateService) {
		this._menuSubject = new BehaviorSubject<boolean>(false);
	}

	/**
	 * Get global menu state
	 *
	 * @returns
	 */
	public get menuStateObservable(): Observable<boolean> {
		return this._menuSubject.asObservable();
	}

	public set menuState(newStatus: boolean) {
		this._menuSubject.next(newStatus);
	}

	/**
	 * Returns the translated key for the menu item
	 *
	 * @param key
	 */
	getByMenuItem(key: MenuItem): string {
		switch (key) {
			case MenuItem.REGISTER:
				return this.translateService.instant('translationService.title.register');

			case MenuItem.LAB_REGISTER:
				return this.translateService.instant('translationService.title.laboratoryRegistration');

			case MenuItem.DENTIST_REGISTER:
				return this.translateService.instant('translationService.title.dentistRegistration');

			case MenuItem.LOGIN:
				return this.translateService.instant('translationService.title.login');

			case MenuItem.FORGOT_USERNAME:
				return this.translateService.instant('translationService.button.forgotUsername');

			case MenuItem.FORGOT_PASSWORD:
				return this.translateService.instant('translationService.button.forgotPassword');

			case MenuItem.RESET_PASSWORD:
				return this.translateService.instant('translationService.button.resetPassword');

			case MenuItem.WELCOME:
				return this.translateService.instant('translationService.title.welcome');

			case MenuItem.MY_USER:
				return this.translateService.instant('translationService.title.myAccount');

			case MenuItem.MY_USER_DATA:
				return this.translateService.instant('translationService.button.userDetails');

			case MenuItem.CHANGE_PASSWORD:
				return this.translateService.instant('translationService.button.changePassword');

			case MenuItem.MY_COMPANY:
				return this.translateService.instant('translationService.title.myCompany');

			case MenuItem.MY_COMPANY_DATA:
				return this.translateService.instant('translationService.button.companyInfo');

			case MenuItem.MY_BILLING_SHIPPING_ADDRESS:
				return this.translateService.instant('translationService.button.addresses');

			case MenuItem.LAB_PROFILE:
				return this.translateService.instant('translationService.button.laboratoryProfile');

			case MenuItem.ADDITIONAL_ORDER_INFORMATION:
				return this.translateService.instant('translationService.button.additionalOrderOptions');

			case MenuItem.DISABLE_ACCOUNT:
				return this.translateService.instant('translationService.button.deactivateAccount');

			case MenuItem.PARTNER:
				return this.translateService.instant('translationService.title.partner');

			case MenuItem.MY_FAVOURITE_TRANSMITTER:
				return this.translateService.instant('translationService.button.mySender');

			case MenuItem.MY_FAVOURITE_RECIPIENTS:
				return this.translateService.instant('translationService.button.myRecipients');

			case MenuItem.CONNECT_DIRECT:
				return this.translateService.instant('translationService.button.connectDirect');

			case MenuItem.LINKED_PORTALS:
				return this.translateService.instant('translationService.button.linkedPortals');

			case MenuItem.ORDER_LIST:
				return this.translateService.instant('translationService.title.orderList');

			case MenuItem.RECEIVED_ORDERS:
				return this.translateService.instant('translationService.button.receivedOrders');

			case MenuItem.SEND_ORDERS:
				return this.translateService.instant('translationService.button.sentOrders');

			case MenuItem.USER_ADMINISTRATION:
				return this.translateService.instant('translationService.title.userManagement');

			case MenuItem.USER_LIST:
				return this.translateService.instant('translationService.button.userList');

			case MenuItem.CONNECT_CASE_CENTER_INBOX:
				return this.translateService.instant('translationService.title.connectInBox');

			case MenuItem.CONNECT_INBOX_WORKSTATIONS:
				return this.translateService.instant('translationService.button.connectInBoxWorkstations');

			default:
				return key;
		}
	}
}
